import {I18N_SELECTABLE_OPTIONS_KEY, I18N_VALUE_CODE_KEY, I18N_VALUE_HELP_MESSAGE_KEY} from 'lf-at-theme';
import {catalogs, ktI18nFn} from '../../../shared';

const {allCountriesCodeOnlyOptions} = catalogs.countries.i18n_en_US;

/**
 * Import form i18n object for the en-US locale.
 */

export const importFormI18nEnUS: Record<string, any> = {
  '/import-form': {
    label: 'Import Scheme - Registration',
    identificationOfBusiness: 'VAT Identification Number',
    taxReferenceNumber: 'Tax Reference Number (if no VAT Identification Number is available)',
    validations: {
      BUSINESS_AND_ISSUING_COUNTRIES_NOT_EQUAL: '[Issuing country](lf://./identificationOfBusiness/issuingCountry) must be equal either the [Country of Business](lf://./countryOfBusiness) or the [Region/Territory](lf://./cobRegion).',
      COB_REGION_SHOULD_BE_USED: ktI18nFn(({parentA2, regionA2}) => `To use the chosen [Issuing Country](lf://./identificationOfBusiness/issuingCountry), the [Country of Business](lf://./countryOfBusiness) and [Region/Territory](lf://./cobRegion) must be respectively changed to ${parentA2} and ${regionA2}.`),
      ISSUER_COUNTRY_NOT_EQUAL_PARENT: '[Issuing country](lf://./identificationOfBusiness/issuingCountry) must be equal to the [Country of Business](lf://./countryOfBusiness).',
      ISSUING_COUNTRY_NOT_EQUAL_REGION: '[Issuing country](lf://./identificationOfBusiness/issuingCountry) must be equal to the [Region/Territory of Business](lf://./cobRegion).',
      ISSUING_COUNTRY_MS_IS_EU_COUNTRY: 'You can only fill-in a Member State as [Tax Identification Number Issuer](lf://./identificationOfBusiness/issuingCountry) when tax numbers associated with that region have that Member State as the issuing country. It must indicate the same value as in [Região](lf://./cobRegion).',
      ISSUER_COUNTRY_XIXU_NOT_ALLOWED: '[Issuing country](lf://./identificationOfBusiness/issuingCountry) cannot be "XI - Northern Ireland" nor "XU - United Kingdom without Northern Ireland". "GB - United Kingdom" should be used instead.',
    }
  },

  '/?/meetsConditions': {
    label: 'I confirm that I meet the conditions to register for this scheme.'
  },

  '/?/currVatId': {
    netpVat: 'VAT Identification Number',
    netpHelp: 'Individual VAT identification number allocated by the Member State of identification in accordance with Article 369q(1) or (3) of Directive 2006/112/EC',
    intermediaryVat: 'Intermediary Number (if any)',
    intermediaryHelp: 'If the taxable person is represented by an intermediary, the individual identification number of that intermediary allocated in accordance with Article 369q(2) of Directive 2006/112/EC',
  },
  '/?/currVatId/vatIdNum': {
    legend: 'Filled-in by the system after approval'
  },


  '/?/intermediaryVat': {
    [I18N_VALUE_CODE_KEY]: '1a',
    legend: 'Filled-in by the system',
  },

  '/?/changePlaceOfBusiness': {
    label: 'Taxable person has changed Place Of Business or Fixed Establishment',
  },

  '/?/identificationOfBusiness': {
    label: 'VAT Identification Number',
  },
  '/?/identificationOfBusiness/issuingCountry': {
    label: 'Country',
    [I18N_SELECTABLE_OPTIONS_KEY]: allCountriesCodeOnlyOptions,
    [I18N_VALUE_CODE_KEY]: '2a'
  },
  '/?/identificationOfBusiness/vatIdNum': {
    label: 'VAT Number',
    validations: {
      NIF_WITH_NO_CADASTRO: 'Unknown NIF',
      NIF_WITH_NO_VAT_ACTIVITY: 'NIF does not have open VAT activity',
      NIF_WITH_NO_FIXED_ESTAB: 'NIF does not have a fixed establishment',
    }
  },
  '/?/identificationOfBusiness/taxRefNum': {
    label: 'Tax Reference Number',
    [I18N_VALUE_CODE_KEY]: '2'
  },

  '/?/countryOfBusiness': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Country in which the taxable person has his place of business'
  },

  '/?/fixedEstablishments/?/taxIdentif/vatIdNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Individual VAT identification number(s) or, if not available, tax reference number(s) allocated by the Member State(s) in which the taxable person has a fixed establishment(s) other than the Member State of identification.'
  },

  '/?/fixedEstablishments/?/taxIdentif/taxRefNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Tax Reference Number given by the Member State'
  },


  '/?/prevOrCurrOssVatId': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Individual VAT identification number(s) allocated by the Member State of identification in accordance with Articles 362, 369d or 369q of Directive 2006/112/EC if the taxable person has previously used or is currently using one of these schemes'
  },

  // Consent / Change of MSID
  '/?/registration': {
    label: 'Notices',
  },

  '/?/relevantDates/registrationReqDate': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Date of request by the taxable person or the intermediary acting on his behalf to be registered under the scheme'
  },

  '/?/relevantDates/forecastStartDate': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Date of registration decision by the Member State of identification'

  },
};
